<template>
  <div class="wx_opentags_box">
    <div class="wx_opentags_contentbox">
      <wx-open-launch-app
        appid="wxb062331269cec15f"
        :extinfo="linkAdrUrl"
        @error="handleFooterErrorFn"
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: blue;
          overflow: hidden;
          /* 透明度如果不为零，在微信内点开卡片，几个跳转按钮会有很奇怪的背景色 */
          opacity: 0;
        "
      >
        <component :is="wxTagComponent" />
      </wx-open-launch-app>
    </div>
  </div>
</template>

<script setup lang="ts">
import { appInfo } from "@eastmoney/mku";
import _envObj from "@/utils/env";

/** data */
import { ref } from "vue";
const linkAdrUrl = ref("");

/** events */
const emit = defineEmits(["linkAppMed"]);

/****************************** methods ******************************/

const handleFooterErrorFn = () => {
  console.log("拉起失败...");
  emit("linkAppMed");
};

/****************************** lifecircle ******************************/

/** created */
import { defineComponent, h } from "vue";
const wxTagComponent = defineComponent({
  render() {
    return h("script", {
      type: "text/wxtag-template",
      innerHTML: "打开东方财富App".repeat(100),
    });
  },
});
let targetUrl =
  window.location.origin + "/views/finskillshub/maintain?from=wxopen";
if (appInfo.isIOS) {
  linkAdrUrl.value =
    "eastmoney://wireless/h5/trade?encode=0&url=" + encodeURIComponent(targetUrl);
} else {
  linkAdrUrl.value = "dfcft://router/h5?url=" + encodeURIComponent(targetUrl);
}
console.log("微信开放标签跳转地址", linkAdrUrl.value);
</script>
<style lang="scss" scoped>
.wx_opentags_box {
  // width: 100%;
  // height: 100%;
  .wx_opentags_contentbox {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 68;
    width: 100%;
    height: 100%;

    .wx_opentags_contentbox {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
